import { useCallback } from 'react';
import { APP_DOWNLOAD_LINK } from '../../../../ui/discovery/AppDiscoveryMobile';
import { useIsMobile } from '../../../../utils/getIsMobile';
import { useOpenDialog } from '../../../ModalRoute';
import { DIALOGS } from '../../../constants';

export const usePostAdCardActions = () => {
    const isMobile = useIsMobile();
    const openDialog = useOpenDialog();

    const onPostAdCardCompactAltClick = useCallback(() => {
        if (isMobile) {
            window.open(APP_DOWNLOAD_LINK, '_blank');
        } else {
            openDialog(DIALOGS.APPS_QR);
        }
    }, [isMobile, openDialog]);

    return {
        onPostAdCardCompactAltClick,
    };
};
